<script>
import Footer from "@/components/restrito/Footer.vue";
import { http } from "@/services/config";
import QrcodeVue from "qrcode.vue";

import dayjs from "dayjs";
import "dayjs/locale/pt-br";
dayjs.locale("pt-br");

export default {
  components: { Footer, QrcodeVue },
  mounted() {
    this.empresa = this.$route.params.empresa;
    this.id = this.$route.params.id;
    if (!this.imagemFixa) this.despedidas();
    window.addEventListener("keydown", this.onTeclaPularStandby);

    // Configura um loop para chamar recarregar a cada 10 minutos (600.000ms)
    this.interval = setInterval(() => {
      window.location.reload();
    }, 600000);
  },

  beforeUnmount() {
    clearInterval(this.interval);
    this.pararStandbyCarousel();
    window.removeEventListener("keydown", this.onTeclaPularStandby);
  },
  computed: {
    imagemFixa() {
      const { empresa, id } = this.$route.params;
      if (empresa?.toUpperCase() === "SM" && id?.toLowerCase() === "fixa") {
        return require("@/assets/propagandas/sm/sm_fixa.png");
      }
      return null;
    },
  },
  watch: {
    propaganda(val) {
      if (val) {
        this.standbyCarouselIndex = 0;
        this.$nextTick(() => this.iniciarStandbyCarousel());
      } else {
        this.pararStandbyCarousel();
      }
    },
  },
  methods: {
    getFotoPadrao(item) {
      const sexo = item?.pessoa_falecida?.sexo || "Masculino";
      return sexo === "Feminino"
        ? require("@/assets/feminino.png")
        : require("@/assets/masculino.png");
    },
    convertToEmbed(url) {
      if (!url) return "";
      /* eslint-disable */
      // eslint-disable-next-line no-useless-escape
      const regex =
        /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:watch\?v=|embed\/)|youtu\.be\/)([^&?\/]+)/;
      const match = url.match(regex);
      const videoId = match ? match[1] || match[2] : null;
      return videoId ? `https://www.youtube.com/embed/${videoId}` : "";
    },
    formatDateHour(date) {
      if (!date) return "Não definido";
      return dayjs(date, "YYYY-MM-DD HH:MM:SS").format("DD/MM/YYYY - HH:mm");
    },
    formatDate(date) {
      if (!date) return "Não definido";
      return dayjs(date, "YYYY-MM-DD").format("DD/MM/YYYY");
    },
    async despedidas() {
      try {
        const response = await http.get(
          `exibicao/despedida-capela/${this.empresa}/${this.id}`,
        );
        this.despedida = response.data;
        this.falecido = this.despedida.pessoa_falecida;
        this.moderador = this.despedida.pessoa_moderador;
        this.value_qrcode = "https://wa.me/5582991743028";
        this.qrCodePosteMensagem =
          "https://parquedasrecordacoes.com.br/despedida/" + this.despedida.id;

        // Após concluir despedidas, chama consultarMensagens()
        await this.consultarMensagens();
      } catch (error) {
        this.propaganda = true; // Caso de erro na consulta, mostra a propaganda
        console.error("Erro ao consultar despedidas:", error);
      }
    },

    async consultarMensagens() {
      try {
        if (!this.despedida || !this.despedida.id) {
          console.error("Erro: despedida ainda não foi carregada.");
          return;
        }

        const response = await http.get(
          `homenagem/homenagem-aprovadas/${this.despedida.id}`,
        );
        this.posts = response.data;
        this.loading = false;
      } catch (error) {
        console.error("Erro ao buscar mensagens:", error);
        this.loading = false;
      }
    },

    // Função para converter o arquivo para Base64
    convertToBase64(file) {
      return new Promise((resolve, reject) => {
        if (!file || !(file instanceof Blob)) {
          resolve(""); // Retorna uma string vazia se o arquivo for inválido
          return;
        }
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(file); // Converte o arquivo para Base64
      });
    },
    valorQrCode() {
      let switchEmpresa = this.empresa.toUpperCase();
      switch (switchEmpresa) {
        case "CV":
          return "https://api.whatsapp.com/send?phone=55828000091700";
        case "PF":
          return "https://api.whatsapp.com/send?phone=5582999692001&text=Ol%C3%A1,%20quero%20solicitar%20um%20arranjo.";
        case "ME":
          return "https://api.whatsapp.com/send?phone=5582991743028";
        case "PA":
          return "https://api.whatsapp.com/send?phone=55828000091700";
        case "CP":
        case "SM":
          return "https://api.whatsapp.com/send?phone=55828000091700";
        default:
          return false;
      }
    },
    getLogo() {
      let switchEmpresa = this.empresa.toUpperCase();
      switch (switchEmpresa) {
        case "CV":
          return "Previda.png";
        case "PF":
          return "ParqueFlores.png";
        case "ME":
          return "Memorial.png";
        case "PA":
          return "ParqueAgreste.png";
        case "CP":
        case "SM":
          return "CemiterioPrevida.png";
        default:
          return "GRUPOPARQUE.png";
      }
    },
    getLogoSecondaria() {
      let switchEmpresa = this.empresa.toUpperCase();
      switch (switchEmpresa) {
        case "CV":
          return "Floresvida.png";
        case "PF":
          return "AFlorDoCafe.png";
        case "ME":
          return "MemorialFlores.png";
        default:
          return null;
      }
    },
    getPropaganda(index) {
      const formattedIndex = String(index).padStart(2, "0");
      return `${formattedIndex}${this.empresa.toUpperCase()}-Finados2026`;
    },
    getPropagandaPath(index) {
      if (!this.empresa) return null;
      const pasta = this.empresa.toLowerCase();
      const baseName = this.getPropaganda(index);
      try {
        return require(`../../assets/propagandas/${pasta}/${baseName}.jpg`);
      } catch (e) {
        try {
          return require(`../../assets/propagandas/${pasta}/${baseName}.png`);
        } catch (e2) {
          return null;
        }
      }
    },
    getPropagandasCount() {
      if (!this.empresa) return 0;
      const emp = this.empresa.toUpperCase();
      if (emp === "CV") return 1;
      if (emp === "PF") return 13;
      if (emp === "PA") return 12;
      if (emp === "CP") return 13;
      if (emp === "SM") return 7;
      if (emp === "ME") return 19;
      return 0;
    },
    getLogosCount() {
      let count = 2;
      if (this.getLogoSecondaria() != null) count++;
      return count;
    },
    getTotalStandbySlides() {
      return this.getLogosCount() + this.getPropagandasCount();
    },
    isSlideCampanha(index) {
      return index >= this.getLogosCount() && this.getPropagandasCount() > 0;
    },
    getDuracaoSlideStandby(index) {
      return this.isSlideCampanha(index)
        ? this.intervalCampanhaMs
        : this.intervalLogosMs;
    },
    iniciarStandbyCarousel() {
      this.pararStandbyCarousel();
      this.agendarProximoSlideStandby();
    },
    agendarProximoSlideStandby() {
      if (!this.propaganda) return;

      const total = this.getTotalStandbySlides();
      if (total <= 1) return;

      const duracao = this.getDuracaoSlideStandby(this.standbyCarouselIndex);
      this.standbyTimer = setTimeout(() => {
        this.standbyCarouselIndex = (this.standbyCarouselIndex + 1) % total;
        this.agendarProximoSlideStandby();
      }, duracao);
    },
    pularSlideStandby() {
      if (!this.propaganda) return;
      const total = this.getTotalStandbySlides();
      if (total <= 1) return;
      this.pararStandbyCarousel();
      this.standbyCarouselIndex = (this.standbyCarouselIndex + 1) % total;
      this.agendarProximoSlideStandby();
    },
    onTeclaPularStandby(event) {
      if (!this.propaganda) return;
      if (event.key !== " " && event.key !== "ArrowRight") return;
      event.preventDefault();
      this.pularSlideStandby();
    },
    pararStandbyCarousel() {
      if (this.standbyTimer) {
        clearTimeout(this.standbyTimer);
        this.standbyTimer = null;
      }
    },
    converterEspaçosEmBr(texto) {
      if (!texto) return ""; // Verifica se o texto é válido
      return texto.replace(/ /g, "%20");
    },
  },
  data: () => ({
    propaganda: false,
    alert_msg: false,
    msg_dialog: "",
    mensagem: false,
    posts: [],
    post_new: {
      img: "",
      msg: "",
      autor: "",
      url: "",
    },
    id: null,
    empresa: "",
    falecido: {},
    moderador: {},
    despedida: {
      foto_fundo: 1,
    },
    tab: "1",
    loading: true,
    value_qrcode: "",
    qrCodePosteMensagem: "",
    size: 140, // Aumentando o tamanho do QR code
    standbyCarouselIndex: 0,
    standbyTimer: null,
    intervalLogosMs: 10000,
    intervalCampanhaMs: 30000,
  }),
};
</script>

<template>
  <div class="carousel-container-standby" v-if="imagemFixa">
    <img :src="imagemFixa" class="slide-media-standby-banner" />
  </div>

  <div class="container" v-else-if="!propaganda">
    <section
      class="banner"
      :style="{
        backgroundImage: `url(${require(`@/assets/pack-banners/${despedida.foto_fundo}.jpg`)})`,
      }"
    >
      <div class="imgperfil">
        <img
          :src="
            getFotoPerfilUrl(despedida.nome_arquivo_foto_perfil) ||
            getFotoPadrao(despedida)
          "
          alt="Foto de Perfil"
        />
      </div>
    </section>

    <section class="dados">
      <h1>{{ falecido.nome_social || falecido.nome }}</h1>
      <div class="date">
        <div class="star">
          <img src="@/assets/images/icons/star.png" alt="Star icon" />
        </div>
        <h2>{{ formatDate(falecido.data_nascimento) }}</h2>
        <div class="cross">
          <img src="@/assets/images/icons/cross.png" alt="Cross icon" />
        </div>
        <h2>{{ formatDate(falecido.data_falecimento) }}</h2>
      </div>
    </section>

    <!-- v-container para as seções -->
    <v-container class="card-container">
      <v-row v-if="despedida.obituario">
        <v-col cols="12" md="12">
          <h2 class="title">Biografia</h2>
          <p class="msgobtuario">{{ despedida.obituario }}</p>
        </v-col>
      </v-row>
      <v-row class="mt-6" dense>
        <v-col cols="12" sm="6" class="px-3">
          <v-card
            class="ceremony-card elevation-4 pa-4"
            style="
              background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
              border-left: 4px solid #343f53;
              border-radius: 12px;
              transition: all 0.3s ease;
              min-height: 140px;
            "
            hover
          >
            <div class="d-flex align-start">
              <div class="icon-container mr-4">
                <v-avatar
                  size="48"
                  style="background: linear-gradient(135deg, #343f53, #2a3441)"
                >
                  <v-icon color="white" size="24">mdi-human-male-female</v-icon>
                </v-avatar>
              </div>
              <div class="info flex-grow-1">
                <h3
                  class="text-h6 font-weight-bold mb-2"
                  style="color: #343f53"
                >
                  Velório
                </h3>
                <div
                  class="text-body-1 mb-1"
                  style="color: #34495e; line-height: 1.5"
                >
                  <v-icon small color="#343f53" class="mr-1">mdi-candle</v-icon>
                  {{ despedida.local_velorio }}
                </div>
                <div class="text-body-2 mb-6" style="color: #7f8c8d">
                  <v-icon small color="#343f53" class="mr-1"
                    >mdi-clock-outline</v-icon
                  >
                  {{ formatDateHour(despedida.data_velorio) }}
                </div>
              </div>
            </div>
          </v-card>
        </v-col>

        <!-- Sepultamento -->
        <v-col cols="12" sm="6" class="px-3">
          <v-card
            class="ceremony-card elevation-4 pa-4"
            style="
              background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
              border-left: 4px solid #4a5568;
              border-radius: 12px;
              transition: all 0.3s ease;
              min-height: 140px;
            "
            hover
          >
            <div class="d-flex align-start">
              <div class="icon-container mr-4">
                <v-avatar
                  size="48"
                  style="background: linear-gradient(135deg, #4a5568, #343f53)"
                >
                  <v-icon color="white" size="24">mdi-coffin</v-icon>
                </v-avatar>
              </div>
              <div class="info flex-grow-1">
                <h3
                  class="text-h6 font-weight-bold mb-2"
                  style="color: #343f53"
                >
                  Sepultamento
                </h3>
                <div class="text-body-1 mb-1" style="color: #34495e">
                  <v-icon small color="#4a5568" class="mr-1"
                    >mdi-map-marker</v-icon
                  >
                  {{
                    despedida.local_sepultamento?.replace("CEMITERIO", "CEM.")
                  }}
                  <br />
                  <v-icon small color="#4a5568" class="mr-1"
                    >mdi-grave-stone</v-icon
                  >{{ despedida.localizacao_sepultado }}
                </div>
                <div class="text-body-2" style="color: #7f8c8d">
                  <v-icon small color="#4a5568" class="mr-1"
                    >mdi-clock-outline</v-icon
                  >
                  {{ formatDateHour(despedida.data_sepultamento) }}
                </div>
              </div>
            </div>
          </v-card>
        </v-col>
      </v-row>
      <v-row class="pb-0" v-if="posts.length > 0">
        <v-col cols="12">
          <h2 class="title">Mensagens</h2>
          <v-progress-circular
            v-if="loading"
            indeterminate
            size="64"
            color="primary"
            class="mx-auto d-flex justify-center"
          ></v-progress-circular>
          <v-carousel
            v-else
            cycle
            hide-delimiters
            height="auto"
            :show-arrows="false"
            interval="10000"
            class="pt-4"
          >
            <v-carousel-item v-for="(item, index) in posts" :key="index">
              <v-card elevation="0" class="text-center">
                <v-card-text class="carousel-content">
                  <div class="content-text">"{{ item.descricao }}"</div>
                  <div v-if="item.nome" class="content-info mt-4">
                    - {{ item.nome }}
                  </div>
                </v-card-text>
              </v-card>
            </v-carousel-item>
          </v-carousel>
        </v-col>
      </v-row>
    </v-container>
    <!-- Container do QR Code -->
    <v-container fluid class="qr-container" v-if="valorQrCode()">
      <v-row>
        <v-col cols="6" class="py-0 d-flex justify-start">
          <!-- QR Code -->
          <div class="qr-text-container">
            <qrcode-vue
              :value="qrCodePosteMensagem"
              :size="size"
              level="H"
              class="qr-code"
            />
            <p class="qr-text">Poste sua mensagem!</p>
          </div>
        </v-col>
        <v-col cols="6" class="py-0 d-flex justify-end">
          <!-- QR Code -->
          <div class="qr-text-container">
            <p class="qr-text">Homenageie com flores!</p>
            <!-- Para PF usa o QR code pronto, para as demais gera dinamicamente -->
            <template v-if="empresa && empresa.toUpperCase() === 'PF'">
              <div class="qr-code">
                <img
                  :src="require('@/assets/images/qr_code_flor_cafe.png')"
                  alt="QR Code Flores"
                  class="qr-code-img"
                  :style="{ width: size + 20 + 'px', height: size + 20 + 'px' }"
                />
              </div>
            </template>
            <template v-else>
              <qrcode-vue
                :value="valorQrCode()"
                :size="size"
                level="H"
                class="qr-code"
              />
            </template>
          </div>
        </v-col>
      </v-row>
    </v-container>
    <Footer v-if="!propaganda" />
  </div>

  <div
    class="carousel-container-standby"
    v-else
    @click="pularSlideStandby"
    title="Clique para pular"
  >
    <v-carousel
      v-model="standbyCarouselIndex"
      :show-arrows="false"
      hide-delimiters
      height="auto"
      width="100%"
    >
      <!-- Logo Grupo Parque -->
      <v-carousel-item class="carousel-item-standby">
        <img
          :src="require('../../assets/images/logos/grupoparque2.png')"
          class="slide-media-standby"
        />
      </v-carousel-item>

      <!-- Logo da Empresa -->
      <v-carousel-item class="carousel-item-standby">
        <img
          :src="require(`../../assets/images/logos/${getLogo()}`)"
          class="slide-media-standby"
        />
      </v-carousel-item>

      <!-- Logo Floricultura (secundária) -->
      <v-carousel-item
        class="carousel-item-standby"
        v-if="getLogoSecondaria() != null"
      >
        <img
          :src="require(`../../assets/images/logos/${getLogoSecondaria()}`)"
          class="slide-media-standby"
        />
      </v-carousel-item>

      <!-- Banner Propagandas (Dia dos Pais) -->
      <template v-if="empresa">
        <v-carousel-item
          class="carousel-item-standby"
          v-for="index in getPropagandasCount()"
          :key="'propaganda-' + index"
        >
          <img
            v-if="getPropagandaPath(index)"
            :src="getPropagandaPath(index)"
            class="slide-media-standby-banner"
          />
        </v-carousel-item>
      </template>
    </v-carousel>
  </div>
</template>

<style scoped>
/* Estilo do banner */
.banner {
  height: 10vh;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;
  position: relative;
}

.banner div {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.banner div img {
  border-radius: 100%;
  width: 300px;
  height: 300px;
  position: absolute;
  bottom: 0;
  transform: translateY(50%);
  object-fit: cover;
}

/* Estilo para as seções */
.dados {
  margin-top: 8rem;
}

.dados h1 {
  text-align: center;
  color: #343f53;
  font-weight: 900;
  font-size: 48px;
  margin-top: 1rem;
}

.date {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
}

.star,
.cross {
  display: flex;
  align-items: center;
  justify-content: center;
}

.star img,
.cross img {
  width: 20px;
}

.cross {
  margin-left: 1rem;
}

.date h2 {
  text-align: center;
  color: #343f53;
  font-weight: 300;
  font-size: 20px;
}

.card-container {
  min-height: 10vh;
  padding-bottom: 0 !important;
}

/* Títulos e conteúdo da biografia e localização */
.title {
  color: #343f53;
  font-size: 2.4rem;
  margin-bottom: 0.5rem;
  font-weight: 600;
  display: inline-block;
  position: relative;
  padding-top: 1rem;
}

.title::after {
  content: "";
  display: block;
  width: 100%;
  height: 3px;
  background-color: #343f53;
  position: absolute;
  bottom: 0;
  left: 0;
}

.subtitle {
  color: #343f53;
  font-size: 1.5rem;
  font-weight: 500;
}

.msgobtuario {
  margin-top: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #343f53;
  font-size: 1.3rem;
  text-align: justify;
}

.info {
  width: 36vw;
  text-align: justify;
  color: #343f53;
  font-size: 1.2rem;
}

/* Estilo do Carrossel */
.carousel-media_img {
  filter: brightness(0) invert(20%) sepia(80%) saturate(500%) hue-rotate(180deg);
  width: 10rem;
}

.multi-carousel .v-carousel-item {
  height: 18vh;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 1rem 0;
  padding-bottom: 0;
}

.carousel-card {
  border-radius: 8px;
  background-color: white;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  margin: 0.5rem auto;
  width: 70%;
  height: 12vh;
  padding: 0 !important;
}

.carousel-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 0.5rem;
}

.content-text {
  color: #343f53;
  font-size: 1.8rem;
  line-height: 1.4;
  padding: 0;
  max-height: 10vh !important;
  font-style: italic;
  font-family: "Roboto", sans-serif;
}

.content-info {
  font-size: 1.4rem;
  color: #5a5a5a;
  padding: 0.2rem !important;
}

.qr-text-container {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0;
  padding: 0.8rem;
  background-color: rgba(255, 255, 255, 0.95);
  border-radius: 12px;
}

.qr-code {
  padding: 1rem;
  background: white;
  border-radius: 8px;
}

.qr-code-img {
  max-width: 100%;
  height: auto;
  display: block;
}

.qr-text {
  color: #343f53;
  font-size: 1.2rem;
  font-weight: 500;
  margin: 0;
  max-width: 150px;
  text-align: center;
}

/* Container do QR Code */
.qr-container {
  position: relative;
  margin-bottom: 1rem;
  padding: 1rem;
  margin-top: auto;
  background: linear-gradient(to bottom, transparent, rgba(255, 255, 255, 0.5));
}

/* Ajuste do container principal para usar flexbox */
.container {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.card-container {
  flex: 1;
  padding-bottom: 2rem;
}
.carousel-container-standby {
  height: 100dvh;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  box-sizing: border-box;
  cursor: pointer;
}

.carousel-item-standby {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100dvh;
  min-height: 0;
}

img.slide-media-standby {
  width: auto;
  height: 100%;
  max-width: 80vw;
  max-height: 60dvh;
  object-fit: contain;
  margin: auto;
  display: block;
}

img.slide-media-standby-banner {
  width: auto;
  height: 100%;
  max-width: 100vw;
  max-height: 100dvh;
  object-fit: contain;
  margin: auto;
  display: block;
}

.carousel-item-standby {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100dvh;
  min-height: 0;
  box-sizing: border-box;
}
.icon-container {
  flex-shrink: 0;
}

.info {
  min-width: 0;
}

@media (max-width: 600px) {
  .ceremony-card {
    min-height: 120px !important;
  }
}
</style>
